import {
    cleanCommonParams,
} from './common';

const mapBrandParams = (
    isCreate,
    {
        co_branded_video_logos,
        ...params
    },
) => {
    return new Promise((resolve) => {
        resolve({
            brand: {
                ...cleanCommonParams(params),
            },
        });
    });
};

export { mapBrandParams };
